"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tf = __importStar(require("@tensorflow/tfjs"));

var vega_embed_1 = __importDefault(require("vega-embed"));

var utils_1 = require("../util/utils");

var render_utils_1 = require("./render_utils");

function heatmap(container, data) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var options, drawArea, inputValues, originalShape, transposed, transposedShape, values, xTickLabels, yTickLabels, shape, inputArray, _shape, numRows, numCols, row, x, col, y, index, value, _inputArray, _row, _x, _col, _y, _value, embedOpts, spec, colorRange, fill, _fill;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = Object.assign({}, defaultOpts, opts);
            drawArea = render_utils_1.getDrawArea(container);
            inputValues = data.values;

            if (!options.rowMajor) {
              _context.next = 12;
              break;
            }

            if (inputValues instanceof tf.Tensor) {
              originalShape = inputValues.shape;
              transposed = inputValues.transpose();
            } else {
              originalShape = [inputValues.length, inputValues[0].length];
              transposed = tf.tidy(function () {
                return tf.tensor2d(inputValues).transpose();
              });
            }

            utils_1.assert(transposed.rank === 2, 'Input to renderHeatmap must be a 2d array or Tensor2d');
            _context.next = 8;
            return transposed.array();

          case 8:
            inputValues = _context.sent;
            transposed.dispose();
            transposedShape = [inputValues.length, inputValues[0].length];
            utils_1.assert(originalShape[0] === transposedShape[1] && originalShape[1] === transposedShape[0], "Unexpected transposed shape. Original ".concat(originalShape, " : Transposed ").concat(transposedShape));

          case 12:
            values = [];
            xTickLabels = data.xTickLabels, yTickLabels = data.yTickLabels;

            if (!(inputValues instanceof tf.Tensor)) {
              _context.next = 26;
              break;
            }

            utils_1.assert(inputValues.rank === 2, 'Input to renderHeatmap must be a 2d array or Tensor2d');
            shape = inputValues.shape;

            if (xTickLabels) {
              utils_1.assert(shape[0] === xTickLabels.length, "Length of xTickLabels (".concat(xTickLabels.length, ") must match number of rows\n          (").concat(shape[0], ")"));
            }

            if (yTickLabels) {
              utils_1.assert(shape[1] === yTickLabels.length, "Length of yTickLabels (".concat(yTickLabels.length, ") must match number of columns\n          (").concat(shape[1], ")"));
            }

            _context.next = 21;
            return inputValues.data();

          case 21:
            inputArray = _context.sent;
            _shape = _slicedToArray(shape, 2), numRows = _shape[0], numCols = _shape[1];

            for (row = 0; row < numRows; row++) {
              x = xTickLabels ? xTickLabels[row] : row;

              for (col = 0; col < numCols; col++) {
                y = yTickLabels ? yTickLabels[col] : col;
                index = row * numCols + col;
                value = inputArray[index];
                values.push({
                  x: x,
                  y: y,
                  value: value
                });
              }
            }

            _context.next = 29;
            break;

          case 26:
            if (xTickLabels) {
              utils_1.assert(inputValues.length === xTickLabels.length, "Number of rows (".concat(inputValues.length, ") must match\n          number of xTickLabels (").concat(xTickLabels.length, ")"));
            }

            _inputArray = inputValues;

            for (_row = 0; _row < _inputArray.length; _row++) {
              _x = xTickLabels ? xTickLabels[_row] : _row;

              if (yTickLabels) {
                utils_1.assert(inputValues[_row].length === yTickLabels.length, "Number of columns in row ".concat(_row, " (").concat(inputValues[_row].length, ")\n            must match length of yTickLabels (").concat(yTickLabels.length, ")"));
              }

              for (_col = 0; _col < _inputArray[_row].length; _col++) {
                _y = yTickLabels ? yTickLabels[_col] : _col;
                _value = _inputArray[_row][_col];
                values.push({
                  x: _x,
                  y: _y,
                  value: _value
                });
              }
            }

          case 29:
            embedOpts = {
              actions: false,
              mode: 'vega-lite',
              defaultStyle: false
            };
            spec = {
              'width': options.width || drawArea.clientWidth,
              'height': options.height || drawArea.clientHeight,
              'padding': 0,
              'autosize': {
                'type': 'fit',
                'contains': 'padding',
                'resize': true
              },
              'config': {
                'axis': {
                  'labelFontSize': options.fontSize,
                  'titleFontSize': options.fontSize
                },
                'text': {
                  'fontSize': options.fontSize
                },
                'legend': {
                  'labelFontSize': options.fontSize,
                  'titleFontSize': options.fontSize
                },
                'scale': {
                  'bandPaddingInner': 0,
                  'bandPaddingOuter': 0
                }
              },
              'data': {
                'values': values
              },
              'mark': 'rect',
              'encoding': {
                'x': {
                  'field': 'x',
                  'type': options.xType,
                  'scale': {
                    'domain': xTickLabels
                  },
                  'title': options.xLabel
                },
                'y': {
                  'field': 'y',
                  'type': options.yType,
                  'scale': {
                    'domain': yTickLabels
                  },
                  'title': options.yLabel
                },
                'fill': {
                  'field': 'value',
                  'type': 'quantitative'
                }
              }
            };
            _context.t0 = options.colorMap;
            _context.next = _context.t0 === 'blues' ? 34 : _context.t0 === 'greyscale' ? 36 : _context.t0 === 'viridis' ? 38 : 38;
            break;

          case 34:
            colorRange = ['#f7fbff', '#4292c6'];
            return _context.abrupt("break", 40);

          case 36:
            colorRange = ['#000000', '#ffffff'];
            return _context.abrupt("break", 40);

          case 38:
            colorRange = 'viridis';
            return _context.abrupt("break", 40);

          case 40:
            if (colorRange !== 'viridis') {
              fill = spec.encoding.fill;
              fill.scale = {
                'range': colorRange
              };
            }

            if (options.domain) {
              _fill = spec.encoding.fill;

              if (_fill.scale != null) {
                _fill.scale = Object.assign({}, _fill.scale, {
                  'domain': options.domain
                });
              } else {
                _fill.scale = {
                  'domain': options.domain
                };
              }
            }

            _context.next = 44;
            return vega_embed_1.default(drawArea, spec, embedOpts);

          case 44:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.heatmap = heatmap;
var defaultOpts = {
  xLabel: null,
  yLabel: null,
  xType: 'ordinal',
  yType: 'ordinal',
  colorMap: 'viridis',
  fontSize: 12,
  domain: null,
  rowMajor: false
};